export const GET_SCHOOL_HOT_POSTS = 'GET_SCHOOL_HOT_POSTS' as const;
export const GET_SCHOOL_HOT_POSTS_FULFILLED = 'GET_SCHOOL_HOT_POSTS_FULFILLED' as const;
export const GET_SCHOOL_HOT_POSTS_PENDING = 'GET_SCHOOL_HOT_POSTS_PENDING' as const;
export const GET_SCHOOL_HOT_POSTS_REJECTED = 'GET_SCHOOL_HOT_POSTS_REJECTED' as const;
export const GET_SCHOOL_INFO = 'GET_SCHOOL_INFO' as const;
export const GET_SCHOOL_INFO_FULFILLED = 'GET_SCHOOL_INFO_FULFILLED' as const;
export const GET_SCHOOL_INFO_PENDING = 'GET_SCHOOL_INFO_PENDING' as const;
export const GET_SCHOOL_INFO_REJECTED = 'GET_SCHOOL_INFO_REJECTED' as const;
export const GET_SCHOOL_INTERESTS = 'GET_SCHOOL_INTERESTS' as const;
export const GET_SCHOOL_INTERESTS_FULFILLED = 'GET_SCHOOL_INTERESTS_FULFILLED' as const;
export const GET_SCHOOL_INTERESTS_PENDING = 'GET_SCHOOL_INTERESTS_PENDING' as const;
export const GET_SCHOOL_INTERESTS_REJECTED = 'GET_SCHOOL_INTERESTS_REJECTED' as const;
export const GET_SCHOOL_POSTS = 'GET_SCHOOL_POSTS' as const;
export const GET_SCHOOL_POSTS_FULFILLED = 'GET_SCHOOL_POSTS_FULFILLED' as const;
export const GET_SCHOOL_POSTS_PENDING = 'GET_SCHOOL_POSTS_PENDING' as const;
export const GET_SCHOOL_POSTS_REJECTED = 'GET_SCHOOL_POSTS_REJECTED' as const;
export const GET_SCHOOL_RECENT_ACTIVITIES = 'GET_SCHOOL_RECENT_ACTIVITIES' as const;
export const GET_SCHOOL_RECENT_ACTIVITIES_FULFILLED = 'GET_SCHOOL_RECENT_ACTIVITIES_FULFILLED' as const;
export const GET_SCHOOL_RECENT_ACTIVITIES_PENDING = 'GET_SCHOOL_RECENT_ACTIVITIES_PENDING' as const;
export const GET_SCHOOL_RECENT_ACTIVITIES_REJECTED = 'GET_SCHOOL_RECENT_ACTIVITIES_REJECTED' as const;
export const GET_SCHOOL_TOPICS = 'GET_SCHOOL_TOPICS' as const;
export const GET_SCHOOL_TOPICS_FULFILLED = 'GET_SCHOOL_TOPICS_FULFILLED' as const;
export const GET_SCHOOL_TOPICS_PENDING = 'GET_SCHOOL_TOPICS_PENDING' as const;
export const GET_SCHOOL_TOPICS_REJECTED = 'GET_SCHOOL_TOPICS_REJECTED' as const;
